<header class="page-header" [class.page-header--compact]="size() === 'compact'">
  <div class="page-header__main">
    @if (eyebrow().trim()) {
      <div class="page-header__eyebrow">{{ eyebrow() }}</div>
    }
    <div class="page-header__headline">
      <h1 class="page-header__title">{{ title() }}</h1>
      <ng-content select="[titleAside]" />
    </div>
    @if (subtitle().trim()) {
      <p class="page-header__subtitle">{{ subtitle() }}</p>
    }
  </div>
  <div class="page-header__right">
    <ng-content select="[right]" />
  </div>
</header>
